
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.861 3.388c-.01 1.13-.402 2.17-.697 3.231-.125.454-.26.908-.428 1.348-.107.285-.04.463.15.682a24.46 24.46 0 003.53 3.377 1 1 0 00.613.166c1.83-.095 6.146-.95 5.965 2.127-.06 1.01-.616 1.71-1.521 2.018-1.169.394-2.16-.007-3.108-.63-.657-.432-1.29-.9-1.947-1.33a.66.66 0 00-.46-.117c-1.853.475-3.7.98-5.55 1.46-.381.1-.59.327-.762.665-.902 1.742-2.004 3.338-3.55 4.58-1.023.82-2.127 1.34-3.485.837-1.795-.666-2.175-2.508-.709-3.738A12.233 12.233 0 013.09 16.65c1.367-.714 2.777-1.35 4.16-2.033a.832.832 0 00.4-.397c.634-1.761 1.25-3.529 1.847-5.302.045-.134-.057-.345-.141-.493-.54-.95-1.157-1.872-1.626-2.86-.566-1.188-.488-2.461-.127-3.694C8.023.44 9.268-.22 10.813.065c1.034.19 1.6.83 1.822 1.806.113.492.153 1.01.226 1.517zM10.28 6.503c.19-.654.428-1.235.525-1.834.105-.688.146-1.384.121-2.08-.02-.621-.285-.785-.902-.747-.488.028-.64.375-.736.765-.35 1.438.156 2.665.992 3.896zm-.39 7.082l3.167-.834-2.13-2.287-1.038 3.121zm-3.977 3.802l-.083-.133c-1.186.67-2.37 1.343-3.555 2.017a.832.832 0 00-.19.173c-.327.356-.286.491.18.647a1.249 1.249 0 001.107-.144c1.055-.656 1.832-1.575 2.541-2.564v.004zm12.03-3.649l-.038.152c.33.197.645.429.995.579.27.115.563.168.856.156.14-.007.357-.216.38-.356.015-.113-.198-.357-.333-.38-.618-.079-1.24-.11-1.86-.155v.004z"}})])
          )
        }
      }
    